import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

export default function Monitoring(props: IconSvgProps) {
  return (
    <BaseLibraryIconSvg {...props} viewBox='0 0 32 32'>
      <g clipPath='url(#clip0)'>
        <path
          d='M4.89189 31.436H0.945946C0.418919 31.436 0 31.0171 0 30.4901V21.8415C0 21.3144 0.418919 20.8955 0.945946 20.8955H4.89189C5.41892 20.8955 5.83784 21.3144 5.83784 21.8415V30.4901C5.83784 31.0171 5.41892 31.436 4.89189 31.436ZM1.89189 29.5442H3.94595V22.7874H1.89189V29.5442Z'
          fill='currentColor'
        />
        <path
          d='M13.6082 31.4361H9.66225C9.13523 31.4361 8.71631 31.0172 8.71631 30.4901V12.4496C8.71631 11.9226 9.13523 11.5037 9.66225 11.5037H13.6082C14.1352 11.5037 14.5541 11.9226 14.5541 12.4496V30.4901C14.5541 31.0172 14.1352 31.4361 13.6082 31.4361ZM10.6217 29.5442H12.6758V13.3956H10.6217V29.5442Z'
          fill='currentColor'
        />
        <path
          d='M22.3379 31.4361H18.392C17.865 31.4361 17.446 31.0172 17.446 30.4901V1.21987C17.446 0.692845 17.865 0.273926 18.392 0.273926H22.3379C22.865 0.273926 23.2839 0.692845 23.2839 1.21987V30.4901C23.2839 31.0172 22.865 31.4361 22.3379 31.4361ZM19.3379 29.5442H21.392V2.16582H19.3379V29.5442Z'
          fill='currentColor'
        />
        <path
          d='M31.054 31.436H27.1081C26.581 31.436 26.1621 31.0171 26.1621 30.4901V20.7333C26.1621 20.2063 26.581 19.7874 27.1081 19.7874H31.054C31.581 19.7874 31.9999 20.2063 31.9999 20.7333V30.4901C31.9999 31.0171 31.581 31.436 31.054 31.436ZM28.054 29.5441H30.1081V21.6792H28.054V29.5441Z'
          fill='currentColor'
        />
      </g>
      <defs>
        {/** biome-ignore lint/correctness/useUniqueElementIds: Automated migration to Biome */}
        <clipPath id='clip0'>
          <rect width='32' height='32' fill='white' />
        </clipPath>
      </defs>
    </BaseLibraryIconSvg>
  );
}
